import axios from "axios";

const loadEmails = (callback) => {
    const config = {
        url: '/api/emails',
        method: 'GET'
    }

    axios.request(config).then(response => callback(response.data));
}

const getEmail = (id, callback) => {
    const config = {
        url: `/api/emails/${id}`,
        method: 'GET'
    }

    axios.request(config).then(response => callback(response.data));
}

const updateEmail = (id, data, callback) => {
    const config = {
        url: `/api/emails/${id}`,
        method: 'PUT',
        data: data
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const SettingActions = {
    loadEmails,
    getEmail,
    updateEmail
}

export default SettingActions;